import { ArrowUpDown } from "lucide-react";
import { useLang } from "@/lib/i18n";

/**
 * The order of a results list, as a row of pills the visitor can swipe on a
 * phone. Every option sorts what is already on screen, so choosing one is
 * instant and never refetches the catalog.
 */
const OPTIONS = [
  { id: "recommended", en: "Recommended", es: "Recomendado" },
  { id: "top", en: "Top rated", es: "Mejor valorados" },
  { id: "new", en: "Newest", es: "Más nuevos" },
  { id: "az", en: "A–Z", es: "A–Z" },
];

export default function ResultsSort({ value, onChange }) {
  const { lang } = useLang();
  return (
    <div className="mb-4 flex items-center gap-2 sm:mb-5">
      <span className="flex shrink-0 items-center gap-1.5 text-[10px] font-black uppercase tracking-[0.14em] text-[#8b877f]">
        <ArrowUpDown className="h-3.5 w-3.5" strokeWidth={2.4} />
        {lang === "es" ? "Ordenar" : "Sort"}
      </span>
      <div className="-mx-1 flex min-w-0 flex-1 items-center gap-1.5 overflow-x-auto no-scrollbar px-1 py-1">
        {OPTIONS.map((option) => {
          const active = value === option.id;
          return (
            <button
              key={option.id}
              type="button"
              onClick={() => onChange(option.id)}
              aria-pressed={active}
              className={`shrink-0 rounded-full border px-3 py-1.5 text-[11px] font-extrabold uppercase leading-none tracking-[0.07em] transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#171717]/40 ${active ? "border-[#171717] bg-[#171717] text-white" : "border-[#deded9] bg-white text-[#4a4741] hover:border-[#171717]/40"}`}
            >
              {lang === "es" ? option.es : option.en}
            </button>
          );
        })}
      </div>
    </div>
  );
}